export default "__VITE_ASSET__C$ZYbtZ$__"